export const auth = (state, action) => {
  return {
    ...state,
    loading: false,
    redirect: '/app/home',
    loggedIn: action.login
  };
};
